<template>
  <NuxtPage
    v-if="data && isSpecificLayout"
    v-bind="data"
    data-test="specific-layout"
  />

  <DefaultLayout
    v-if="data && !isSpecificLayout"
    v-bind="data"
    data-test="default-layout"
  />
</template>

<script lang="ts" setup>
import { useCMSHead } from './composables/useCMSHead'
import { useFetchContent } from './composables/useFetchPageContent'
import { useHandleFetchError } from './composables/useHandleFetchError'
import { useHandleIncorrectRouteParams } from './composables/useHandleIncorrectRouteParams'
import { useIsSpecificLayout } from './composables/useIsSpecificLayout'
import DefaultLayout from './layout/Default.vue'

const { data, error } = await useFetchContent()

useHandleFetchError(error)
useHandleIncorrectRouteParams(data)
useCMSHead(data)
const isSpecificLayout = useIsSpecificLayout(data)
</script>
